<template>
    <div class="tools-wrapper">
        <div class="tools-main">
            <div class="tools-main-title-desc">
                <div class="tools-main-title-desc__header">
                    <the-tools-icon
                        class="tools-main-title-desc__header--logo"
                    ></the-tools-icon>
                    <div class="tools-main-title-desc__header--title">
                        Create
                    </div>
                </div>
                <div class="tools-main-title-desc__description">
                    <p>
                        The user-friendly <strong>Editor</strong> offers both
                        newcomers and veterans a suite of powerful tools to
                        create any game they can imagine, and
                        <strong>Visual Scripting</strong> helps to breathe life
                        into any creation.
                    </p>
                </div>
            </div>
            <div class="tools-main__right-image">
                <ImageOptimized
                    :file-name="'/home/tools/tool-second-section'"
                    :alt="'The Tools'"
                    :sizes="['600', '1000', '1920']"
                    :load="'lazy'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import TheToolsIcon from 'Svgs/the-tools.svg?inline';
import ImageOptimized from '@/components/common/ImageScaler';

export default {
    name: 'TheTools',
    components: {
        TheToolsIcon,
        ImageOptimized,
    },
};
</script>

<style scoped lang="scss">
.tools-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;
    background: yellow url('~Images/home/backgr-home-second-section1.png')
        no-repeat center center;
    background-size: cover;
    margin-top: -8rem;
    padding-top: 8rem;

    .tools-main {
        position: relative;
        display: flex;
        max-width: 1280px;
        width: 100%;
        height: auto;
        justify-content: space-between;
        align-items: center;
        margin: 0 25px;

        @media (max-width: $sm-up) {
            flex-direction: column;
            padding-top: 45px 0;
        }
        .tools-main-title-desc {
            padding: 120px 0;
            flex: 2 1 auto;
            @media (max-width: $sm-up) {
                padding: 0;
            }
            .tools-main-title-desc__header {
                display: flex;
                align-items: center;

                @media (max-width: $sm-up) {
                    justify-content: center;
                }

                @media (max-width: $xs-up) {
                    flex-direction: column;
                }
                &--logo {
                    margin-right: 14px;
                    @media (max-width: $xs-up) {
                        margin-right: 0;
                        margin-bottom: 30px;
                    }
                }
                &--title {
                    text-align: left;
                    color: $blue-main;
                    font-family: $politica-font;
                    font-size: 55px;
                    font-weight: 700;
                    letter-spacing: 2.5px;
                    line-height: 60px;

                    @media (max-width: $xs-up) {
                        font-size: 35px;
                        font-weight: 700;
                        letter-spacing: 0.7px;
                        line-height: 40px;
                        text-align: center;
                    }
                }
            }

            &__description {
                font-family: $palanquin-font;
                font-size: 18px;
                font-weight: 400;
                letter-spacing: 0.56px;
                line-height: 30px;
                color: $blue-main;

                @media (max-width: $sm-up) {
                    text-align: center;
                }
            }
        }

        &__right-image {
            position: relative;
            max-width: 100%;
            margin: 0 auto;
            bottom: 0;
            height: auto;
            align-self: flex-end;
        }
    }
}
</style>
